//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'PROCAMScore',
  data () {
    return {
      form: {
        age: '',
        ldlc: '',
        hdlc: '',
        tag: '',
        smokhis: '',
        diabetes: '',
        stemi: '',
        sbp: ''
      },
      dataList: [
        {value: '0', name: '35-39'},
        {value: '6', name: '40-44'},
        {value: '11', name: '45-49'},
        {value: '16', name: '50-54'},
        {value: '21', name: '55-59'},
        {value: '26', name: '60-65'}
      ],
      dataList2: [
        {value: '0', name: '<100mg/dL'},
        {value: '5', name: '100~129mg/dL'},
        {value: '10', name: '130~159mg/dL'},
        {value: '14', name: '160~189mg/dL'},
        {value: '20', name: '≥190mg/dL'}
      ],
      dataList3: [
        {value: '11', name: '<35mg/dL'},
        {value: '8', name: '35~44mg/dL'},
        {value: '5', name: '45~54mg/dL'},
        {value: '0', name: '≥55mg/dL'}
      ],
      dataList4: [
        {value: '0', name: '<100mg/dL'},
        {value: '2', name: '100~149mg/dL'},
        {value: '3', name: '150~199mg/dL'},
        {value: '4', name: '≥200mg/dL'}
      ],
      dataList5: [
        {value: '8', name: '有'},
        {value: '0', name: '无'}
      ],
      dataList6: [
        {value: '6', name: '有'},
        {value: '0', name: '无'}
      ],
      dataList7: [
        {value: '4', name: '有'},
        {value: '0', name: '无'}
      ],
      dataList8: [
        {value: '0', name: '<120mmHg'},
        {value: '2', name: '120~129mmHg'},
        {value: '3', name: '130~139mmHg'},
        {value: '5', name: '140~159mmHg'},
        {value: '8', name: '≥160mmHg'}
      ],
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }

      let result = form.age + form.ldlc + form.hdlc + form.tag + form.smokhis + form.diabetes + form.stemi + form.sbp
      self.hasScore = true
      switch (result) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
        case 17:
        case 18:
        case 19:
        case 20:
          self.descTxt = 'MI风险<1%'
          break
        case 21:
          self.descTxt = 'MI风险1.1%'
          break
        case 22:
          self.descTxt = 'MI风险1.2%'
          break
        case 23:
          self.descTxt = 'MI风险1.3%'
          break
        case 24:
          self.descTxt = 'MI风险1.4%'
          break
        case 25:
          self.descTxt = 'MI风险1.6%'
          break
        case 26:
          self.descTxt = 'MI风险1.7%'
          break
        case 27:
          self.descTxt = 'MI风险1.8%'
          break
        case 28:
          self.descTxt = 'MI风险1.9%'
          break
        case 29:
          self.descTxt = 'MI风险2.3%'
          break
        case 30:
          self.descTxt = 'MI风险2.4%'
          break
        case 31:
          self.descTxt = 'MI风险2.8%'
          break
        case 32:
          self.descTxt = 'MI风险2.9%'
          break
        case 33:
          self.descTxt = 'MI风险3.3%'
          break
        case 34:
          self.descTxt = 'MI风险3.5%'
          break
        case 35:
          self.descTxt = 'MI风险4.0%'
          break
        case 36:
          self.descTxt = 'MI风险4.2%'
          break
        case 37:
          self.descTxt = 'MI风险4.8%'
          break
        case 38:
          self.descTxt = 'MI风险5.1%'
          break
        case 39:
          self.descTxt = 'MI风险5.7%'
          break
        case 40:
          self.descTxt = 'MI风险6.1%'
          break
        case 41:
          self.descTxt = 'MI风险7.0%'
          break
        case 42:
          self.descTxt = 'MI风险7.4%'
          break
        case 43:
          self.descTxt = 'MI风险8.0%'
          break
        case 44:
          self.descTxt = 'MI风险8.8%'
          break
        case 45:
          self.descTxt = 'MI风险10.2%'
          break
        case 46:
          self.descTxt = 'MI风险10.5%'
          break
        case 47:
          self.descTxt = 'MI风险10.7%'
          break
        case 48:
          self.descTxt = 'MI风险12.8%'
          break
        case 49:
          self.descTxt = 'MI风险13.2%'
          break
        case 50:
          self.descTxt = 'MI风险15.5%'
          break
        case 51:
          self.descTxt = 'MI风险16.8%'
          break
        case 52:
          self.descTxt = 'MI风险17.5%'
          break
        case 53:
          self.descTxt = 'MI风险19.6%'
          break
        case 54:
          self.descTxt = 'MI风险21.7%'
          break
        case 55:
          self.descTxt = 'MI风险22.2%'
          break
        case 56:
          self.descTxt = 'MI风险23.8%'
          break
        case 57:
          self.descTxt = 'MI风险25.1%'
          break
        case 58:
          self.descTxt = 'MI风险28%'
          break
        case 59:
          self.descTxt = 'MI风险29.4%'
          break
        default:
          self.descTxt = 'MI风险≥30%'
          break
      }
      return String(result)
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/PROCAMScore.vue